import React from "react";
import { useSelector } from "react-redux";
import { FooterIcons, FooterSocial, GroupLinks } from "./data";
import Newsletter from "components/newsletter";
import ReferFriend from "components/refer-friend";

const DesktopFooter = ({ data, hideNewsletter, hideReferAFriend }) => {
	const { social, links, authLinks, privacyLinks, icons, newsletter, referFriend } = data ?? {};
	const { authenticated } = useSelector((state) => state.account.profile);

	const displayedLinks = (authenticated && authLinks) ? authLinks : links;

	return (
		<footer className="desktop-footer">
			{authenticated && referFriend?.title ? (
				!hideReferAFriend &&
				<div className="border-solid border-y-[0.06rem] border-[#E9E9E9] py-14 lg:mb-14 px-5 md:px-7">
					<div className="hd-screen-max-width">
						<ReferFriend data={referFriend} />
					</div>
				</div>
			) : (
				!hideNewsletter && <Newsletter data={newsletter} />
			)}
			<div className="desktop-footer-wrapper hd-screen-max-width xxl:px-0">
				<FooterSocial data={social} privacyLinks={privacyLinks} />
				<GroupLinks data={displayedLinks} />
				<FooterIcons icons={icons} />
			</div>
		</footer>
	);
};

export default DesktopFooter;
